<template>
    <b-button :type="type" :variant="variant" :disabled="isBusy" :size="size" :block="isFullwidth">
        <b-spinner v-if="isBusy" small type="grow"></b-spinner>
        {{ isBusy ? loadingText : text }}
    </b-button>
</template>

<script>
    export default {
        name: "LoadingButton",
        props: {
            isBusy: {
                type: Boolean,
                default: false
            },
            isFullwidth: {
              type: Boolean,
              default: false
            },
            loadingText: {
                type: String,
                default: "Подождите"
            },
            type: {
                type: String,
                default: "submit"
            },
            variant: {
                type: String,
                default: "primary"
            },
            text: {
                type: String,
                default: "Сохранить"
            },
            size: {
                type: String,
            },
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>

</style>
